export const
    // Primary palette
    PRIMARY_COLOR = 'rgb(255,46, 88)',

    // Secondary Palette
    SECONDARY_COLOR = 'rgb(59,28,98)',


    // Simple Colors
    WHITE = '#fff',
    BLACK = '#000',
    BLACK_LIGHT = '#bfbfbf',
    GRAY = '#f2f2f2',
    GRAY_LIGHT = '#f2f2f2'